document.addEventListener("DOMContentLoaded", function () {

  // get all button elements with that class name
  const openPopupButton = document.getElementsByClassName("open-popup");
  const closePopupButton = document.getElementsByClassName("close-popup");

  // loop all open popup button elements
  for (let i = 0; i < openPopupButton.length; i++) {
    
    // add a click listener to each button
    openPopupButton[i].addEventListener("click", function (e) {
      e.preventDefault();
      
      // get the added data-popup attribute value
      const popup = this.getAttribute('data-popup');
      
      // display the popup with that ID
      document.getElementById(popup).style.display = "block";
    });
  }

  // loop all close popup button elements
  for (let i = 0; i < closePopupButton.length; i++) {
    
    // add a click listener to each button
    closePopupButton[i].addEventListener("click", function (e) {
      e.preventDefault();

      // get parent element on container to be used on getting the popup and video element
      const parent = this.parentNode;

      // get the popup element and hide it
      parent.parentNode.style.display = "none";

      // get the video element and pause + reset the video
      const videoPlayer = parent.querySelector("video");
      videoPlayer.pause();
      videoPlayer.currentTime = 0;
    });
  }


  /*
  const popupContainer = document.getElementByClassName("popup-container");
  const closePopupButton = document.getElementById("close-popup");
  const openPopupButton = document.getElementByClassName("open-popup"); // Add this line

  // Show the popup when the "Open" link is clicked
  openPopupButton.addEventListener("click", function (e) {
    e.preventDefault(); // Prevent the default link behavior (navigating to a new page)
    popupContainer.style.display = "block";
  });

  // Close the popup when the close button is clicked
  closePopupButton.addEventListener("click", function () {
    popupContainer.style.display = "none";

        // Pause and reset the video
   var videoPlayer = document.getElementById("videoPlayer");
    videoPlayer.pause();
    videoPlayer.currentTime = 0;
  });
  */
  
});




